import { Link, useLocation } from "react-router-dom";
import logoLight from "@/assets/smart-canvas-logo-light.png";
import logoDark from "@/assets/smart-canvas-logo-dark.png";

export function Logo({ className = "" }: { className?: string }) {
  const { pathname } = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    if (pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Link
      to="/"
      onClick={handleClick}
      className={`group inline-flex items-center hover:opacity-70 transition-opacity ${className}`}
      aria-label="Smart Canvas"
    >
      <img
        src={logoLight}
        alt="Smart Canvas"
        className="h-5 w-auto block dark:hidden"
        draggable={false}
      />
      <img
        src={logoDark}
        alt="Smart Canvas"
        className="h-5 w-auto hidden dark:block"
        draggable={false}
      />
    </Link>
  );
}